module.exports = __webpack_public_path__ + "static/media/60Hou@4x.00ff060b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/60Hou@4x.png
// module id = 1680
// module chunks = 0 1